//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SectionMunicipalityEntityContent",
  components: {
    PhotoSign: () => import("@/components/common/PhotoSign"),
    EntityContent: () => import("@/components/common/EntityContent"),
    Section: () => import("@/components/common/Section")
  },
  computed: {
    ...mapGetters({
      description: "municipality/description",
      mediaSource: "municipality/mediaSource"
    })
  }
};
